export function assign<TSource, TUpdater extends TSource>(
  source: TSource,
  updater: TUpdater,
): TSource {
  return {
    ...source,
    ...updater,
  };
}
